import React, { useEffect, useState } from "react";
import ProductCard from "./productCard";
import { Grid } from "@mui/material";
import Header from "./header";
import { useMutation } from "react-query";
import { GetProducts } from "../service/store.service";
import { ApiResultModel } from "../../models/common.model";
import { GetProductsResponse, GetProductsModel } from "../models/store.model";
import { useHistory } from "react-router-dom";
import {
  PARENT_CATEGORY_ID,
  PARENT_CATEGORY_ID_OLD,
} from "../../config/cacheKey";
import ProductCardSkeleton from "./productCardSkeleton";

export default function ProductList() {
  const [data, setData] = useState<GetProductsModel[]>();
  const history = useHistory<{
    parentCategoryId: number;
    path?: any[];
  }>();
  useEffect(() => {
    // if (history.action ==='POP'){
    //   getProducts({

    //     productCategoryId:Number(sessionStorage.getItem(PARENT_CATEGORY_ID_OLD))})
    // }else if (history.action ==='PUSH' || history.action==="REPLACE"){
    getProducts({
      productCategoryId: history.location.state?.parentCategoryId
        ? history.location.state?.parentCategoryId
        : Number(sessionStorage.getItem(PARENT_CATEGORY_ID)),
    });

    // }
  }, []);
  const { mutate: getProducts, isLoading } = useMutation(GetProducts, {
    onSuccess: (data: ApiResultModel<GetProductsResponse>) => {
      if (data.data) {
        setData(data.data.products);
        history.replace({
          state: {
            parentCategoryId: history.location.state?.parentCategoryId,
            path: data.data.categoryPath,
          },
        });
        // sessionStorage.setItem(PARENT_CATEGORY_ID_OLD,data.data.)
      }
    },
  });
  return (
    <>
      {!isLoading ? (
        <Grid container spacing={1} xs={15}>
          <Grid item xs={15}>
            <Header
              search={true}
              category={true}
              // parentCategoryId={undefined}
            />
          </Grid>
          {data?.map((item: GetProductsModel) => (
            <Grid item xs={15} sm={7} md={5} lg={3} xl={2}>
              <ProductCard product={item} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <ProductCardSkeleton />
          </Grid>
        </Grid>
      )}
    </>
  );
}
